// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_container {
  flex-direction: column;
  row-gap: 20px;
  column-gap: 10px;
  display: flex;
  align-items: center;
  width: 100%;
}

.img_logo {
  width: 120px;
}

.title {
  color: white;
  text-align: center;
  font-weight: 800;
  font-style: italic;
  font-size: 40px;
}

.form_signin_container {
  flex-direction: column;
  row-gap: 30px;
  column-gap: 10px;
  display: flex;
  align-items: center;
}

input {
  padding: 10px 0px;
  text-align: center;
  border-radius: 10px;
  border: 2px solid transparent;
  font-size: 18px;
  height: 30px;
  background: linear-gradient(#ff7979, #181A19 0) padding-box, linear-gradient(to right, #F08319, #E51B2F) border-box;
  width: 600px;
  transition: all 0.3s;
  color: white;
}
input:focus {
  outline: none;
  border: 2px solid transparent;
  background: linear-gradient(#ff7979, #181A19 0) padding-box, linear-gradient(to right, #F08319, #E51B2F) border-box;
}

.placeholder {
  position: absolute;
  left: 10px;
  top: 18px;
  transition: all 0.3s ease;
  color: #8E8E8E;
  font-size: 18px;
  pointer-events: none;
  text-align: center;
  width: calc(100% - 20px);
  background: transparent;
  border-radius: 8px;
}

.input-container {
  position: relative;
}

input:focus + .placeholder,
input:not(:placeholder-shown) + .placeholder {
  top: -10px;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  background: #181A19;
  background: linear-gradient(to right, #F08319, #E51B2F);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.background {
  color: #181A19;
  z-index: 0;
  position: absolute;
  background: #181A19;
  left: 40%;
  top: -12px;
  width: 119px;
}

.background_VIN {
  color: #181A19;
  z-index: 0;
  position: absolute;
  background: #181A19;
  left: 39%;
  top: -10px;
  width: 130px;
}

.button_signin {
  padding: 14px 43px;
  max-width: 194px;
  font-size: 20px;
  background: linear-gradient(to right, #F08319, #E51B2F);
  color: white;
  border: none;
  border-radius: 13px;
}
.button_signin:hover {
  background: linear-gradient(to right, rgba(240, 131, 25, 0.7), rgba(229, 27, 47, 0.7));
}

@media (max-width: 600px) {
  .background {
    left: 36%;
    width: 114px;
  }
  .background_VIN {
    left: 35%;
    width: 120px;
  }
  input {
    max-width: 400px;
    font-size: 20px;
  }
}
@media (max-width: 400px) {
  .background {
    left: 30%;
    width: 113px;
  }
  .background_VIN {
    left: 29%;
    width: 120px;
  }
  input {
    max-width: 280px;
    height: 50px;
  }
}
.password-toggle-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.3s;
}
.password-toggle-button:hover {
  opacity: 1;
}
.password-toggle-button svg {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/login.sass"],"names":[],"mappings":"AAMA;EALE,sBAM2B;EAL3B,aAKmC;EAJnC,gBAIyC;EAHzC,aAAA;EAIA,mBAAA;EACA,WAAA;AAFF;;AAIA;EACE,YAAA;AADF;;AAGA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAEA;EApBE,sBAqB2B;EApB3B,aAoBmC;EAnBnC,gBAmByC;EAlBzC,aAAA;EAmBA,mBAAA;AAIF;;AAFA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;EACA,mHAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;AAKF;AAJE;EACE,aAAA;EACA,6BAAA;EACA,mHAAA;AAMJ;;AAHA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,wBAAA;EACA,uBAAA;EACA,kBAAA;AAMF;;AAJA;EACE,kBAAA;AAOF;;AALA;;EAEE,UAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;EACA,uDAAA;EACA,6BAAA;EACA,oCAAA;AAQF;;AANA;EACE,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AASF;;AAPA;EACE,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AAUF;;AARA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uDAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAWF;AAVE;EACE,sFAAA;AAYJ;;AAVA;EACE;IACE,SAAA;IACA,YAAA;EAaF;EAZA;IACE,SAAA;IACA,YAAA;EAcF;EAbA;IACE,gBAAA;IACA,eAAA;EAeF;AACF;AAfA;EACE;IACE,SAAA;IACA,YAAA;EAiBF;EAhBA;IACE,SAAA;IACA,YAAA;EAkBF;EAjBA;IACE,gBAAA;IACA,YAAA;EAmBF;AACF;AAdA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,wBAAA;AAgBF;AAdE;EACE,UAAA;AAgBJ;AAdE;EACE,oBAAA;AAgBJ","sourcesContent":["@mixin default_container($flex-direction: row, $row_gap, $column_gap)\n  flex-direction: $flex-direction\n  row-gap: $row_gap\n  column-gap: $column_gap\n  display: flex\n\n.login_container\n  @include default_container(column, 20px, 10px)\n  align-items: center\n  width: 100%\n\n.img_logo\n  width: 120px\n\n.title\n  color: white\n  text-align: center\n  font-weight: 800\n  font-style: italic\n  font-size: 40px\n\n.form_signin_container\n  @include default_container(column, 30px, 10px)\n  align-items: center\n\ninput\n  padding: 10px 0px\n  text-align: center\n  border-radius: 10px\n  border: 2px solid transparent\n  font-size: 18px\n  height: 30px\n  background: linear-gradient(#ff7979, #181A19 0) padding-box, linear-gradient(to right, #F08319, #E51B2F) border-box\n  width: 600px\n  transition: all 0.3s\n  color: white\n  &:focus\n    outline: none\n    border: 2px solid transparent\n    background: linear-gradient(#ff7979, #181A19 0) padding-box, linear-gradient(to right, #F08319, #E51B2F) border-box\n\n\n.placeholder\n  position: absolute\n  left: 10px\n  top: 18px\n  transition: all 0.3s ease\n  color: #8E8E8E\n  font-size: 18px\n  pointer-events: none\n  text-align: center\n  width: calc(100% - 20px)\n  background: transparent\n  border-radius: 8px\n\n.input-container\n  position: relative\n\ninput:focus + .placeholder,\ninput:not(:placeholder-shown) + .placeholder\n  top: -10px\n  z-index: 2\n  left: 10px\n  font-size: 14px\n  background: #181A19\n  background: linear-gradient(to right, #F08319, #E51B2F)\n  -webkit-background-clip: text\n  -webkit-text-fill-color: transparent\n\n.background\n  color: #181A19\n  z-index: 0\n  position: absolute\n  background: #181A19\n  left: 40%\n  top: -12px\n  width: 119px\n\n.background_VIN\n  color: #181A19\n  z-index: 0\n  position: absolute\n  background: #181A19\n  left: 39%\n  top: -10px\n  width: 130px\n\n.button_signin\n  padding: 14px 43px\n  max-width: 194px\n  font-size: 20px\n  background: linear-gradient(to right, #F08319, #E51B2F)\n  color: white\n  border: none\n  border-radius: 13px\n  &:hover\n    background: linear-gradient(to right, rgba(240, 131, 25, 0.7), rgba(229, 27, 47, 0.7))\n\n@media (max-width: 600px)\n  .background\n    left: 36%\n    width: 114px\n  .background_VIN\n    left: 35%\n    width: 120px\n  input\n    max-width: 400px\n    font-size: 20px\n@media (max-width: 400px)\n  .background\n    left: 30%\n    width: 113px\n  .background_VIN\n    left: 29%\n    width: 120px\n  input\n    max-width: 280px\n    height: 50px\n\n\n\n  // место для кнопки\n\n.password-toggle-button\n  position: absolute\n  right: 10px\n  top: 50%\n  transform: translateY(-50%)\n  background: none\n  border: none\n  cursor: pointer\n  opacity: 0.6\n  transition: opacity 0.3s\n\n  &:hover\n    opacity: 1\n\n  svg\n    pointer-events: none"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
